<template>
  <!--
  <svg :class="class" viewBox="0 0 135 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_66_4" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="135" height="38">
      <path d="M134.727 0H0V38H134.727V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_66_4)">
      <g style="mix-blend-mode:difference">
        <g style="mix-blend-mode:hard-light">
          <path
            d="M0.483823 19.0001C0.483823 9.67261 8.05263 2.11116 17.3893 2.11116C26.7259 2.11116 34.2946 9.67261 34.2946 19.0001C34.2946 28.3276 26.7259 35.8889 17.3893 35.8889C14.0641 35.8889 10.621 34.6495 8.00636 32.9932C5.07356 35.025 1.7126 35.7307 0 35.8162C2.20506 31.1167 0.483823 23.2435 0.483823 19.0001Z"
            fill="currentColor" />
        </g>
        <g style="mix-blend-mode:hard-light">
          <path
            d="M21.0042 25.3811C21.0042 19.7847 25.5455 15.2479 31.1475 15.2479C36.7494 15.2479 41.2907 19.7847 41.2907 25.3811C41.2907 30.9777 36.7494 35.5145 31.1475 35.5145C29.1523 35.5145 27.0839 34.7911 25.5151 33.7973C23.5946 34.8944 21.7427 35.3402 20.7139 35.5802C22.0369 32.7605 21.0042 27.9272 21.0042 25.3811Z"
            fill="url(#paint0_radial_66_4)" />
        </g>
      </g>
      <path
        d="M61.3844 27.8034C57.1021 27.8034 54.7456 26.1314 54.7456 23.1926V23.1166H58.5464V23.3446C58.5464 24.4846 59.256 24.7886 61.4097 24.7886C63.4368 24.7886 63.9182 24.4594 63.9182 23.6994C63.9182 22.99 63.5381 22.7874 62.0432 22.5846L58.4704 22.154C55.9365 21.8754 54.5176 20.7354 54.5176 18.6074C54.5176 16.378 56.418 14.6046 60.7763 14.6046C64.9318 14.6046 67.2883 16.1754 67.2883 19.266V19.342H63.4875V19.19C63.4875 18.1514 62.9807 17.6194 60.6495 17.6194C58.7491 17.6194 58.2677 17.9486 58.2677 18.7594C58.2677 19.418 58.6225 19.6966 60.2948 19.8994L63.006 20.2286C66.4015 20.6086 67.6684 21.7486 67.6684 23.8514C67.6684 26.2326 65.3119 27.8034 61.3844 27.8034ZM76.4488 27.8034C72.2173 27.8034 69.3287 25.726 69.3287 21.2166C69.3287 17.1634 72.1919 14.6046 76.3728 14.6046C80.5284 14.6046 83.2903 16.7834 83.2903 20.7606C83.2903 21.2166 83.2396 21.546 83.189 21.9766H72.8508C72.9521 23.9274 73.8643 24.7634 76.3222 24.7634C78.5773 24.7634 79.3628 24.1806 79.3628 23.0914V22.838H83.1636V23.1166C83.1636 25.878 80.4777 27.8034 76.4488 27.8034ZM76.2968 17.5686C74.0417 17.5686 73.0788 18.3286 72.9014 19.9754H79.6415C79.5402 18.3034 78.5266 17.5686 76.2968 17.5686ZM98.3566 27.55H84.8767V24.3074L90.3245 19.9754L92.9851 18.3034V18.05L90.3245 18.202H85.2568V14.858H97.9765V18.126L92.0983 22.6606L89.6911 24.1554V24.4086L92.0983 24.2314H98.3566V27.55ZM110.028 27.8034C106.455 27.8034 104.758 25.5994 104.758 22.762V14.858H108.559V21.4954C108.559 23.5474 109.42 24.4086 111.828 24.4086C114.31 24.4086 115.197 23.446 115.197 21.2926V14.858H118.998V27.55H115.451V23.674H115.248C114.919 25.802 113.373 27.8034 110.028 27.8034ZM127.858 27.8034C123.577 27.8034 121.22 26.1314 121.22 23.1926V23.1166H125.021V23.3446C125.021 24.4846 125.73 24.7886 127.884 24.7886C129.911 24.7886 130.393 24.4594 130.393 23.6994C130.393 22.99 130.013 22.7874 128.518 22.5846L124.945 22.154C122.411 21.8754 120.992 20.7354 120.992 18.6074C120.992 16.378 122.893 14.6046 127.25 14.6046C131.407 14.6046 133.763 16.1754 133.763 19.266V19.342H129.962V19.19C129.962 18.1514 129.455 17.6194 127.124 17.6194C125.224 17.6194 124.742 17.9486 124.742 18.7594C124.742 19.418 125.097 19.6966 126.77 19.8994L129.48 20.2286C132.876 20.6086 134.143 21.7486 134.143 23.8514C134.143 26.2326 131.787 27.8034 127.858 27.8034Z"
        :fill="isDark ? '#FFFFFF' : '#000000'" />
    </g>
    <defs>
      <radialGradient id="paint0_radial_66_4" cx="0" cy="0" r="1"
        gradientTransform="matrix(-20.3709 19.778 -244.707 -251.935 41.0846 15.2479)" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2563EB" />
        <stop offset="1" stop-color="#1D4ED8" />
      </radialGradient>
    </defs>
  </svg>
  -->
  <!--
    OLD (was causing HMR crash):
      <img src="@/assets/images/newtheme/DJ_Dark.svg" ...>
      <img src="@/assets/images/newtheme/AJ_Logo_White.svg" ...>

    PROBLEM: Vite's @vitejs/plugin-vue transforms src="@/assets/..." in <img> tags
    into JS dynamic module imports at compile time. These SVG files embed raster
    image data (168 KB – 943 KB each), so Vite fails to load them as JS modules
    during HMR, crashing the entire component tree with:
      TypeError: error loading dynamically imported module: .../AJ_Logo_White.svg?import

    FIX: Copied all four logo SVGs to /public/icon/ and switched to absolute /icon/
    paths. Files in /public are served by Vite as plain static assets — they are
    never processed as JS modules, so HMR no longer fails.

    Files copied to /public/icon/:
      DJ_Dark.svg, DJ_light.svg, AJ_Logo_White.svg, AJ_Logo_dark.svg
  -->
  <!-- Brand logo: renders the active theme's dark/light logo image variant based on the current theme preset -->
  <div v-if="themePreset == 'dougjoneslight'" class="logo-container">
    <!-- OLD: src="@/assets/images/newtheme/DJ_Dark.svg" -->
    <img v-if="isDarkMode" src="/icon/cn_dark.svg" alt="The Change Network Logo" class="logo-image">
    <!-- OLD: src="@/assets/images/newtheme/DJ_light.svg" -->
    <img v-else src="/icon/cn_light.svg" alt="The Change Network Logo" class="logo-image">
    <!-- <span class="logo-text text-[#FFF]">The Change Network</span> -->
  </div>
  <div v-if="themePreset === 'allenjackson'" class="logo-container">
    <!-- OLD: src="@/assets/images/newtheme/AJ_Logo_White.svg" -->
    <img v-if="isDarkMode" src="/icon/AJ_Logo_White.svg" alt="Allen Jackson Logo" class="logo-image">
    <!-- OLD: src="@/assets/images/newtheme/AJ_Logo_dark.svg" -->
    <img v-else src="/icon/AJ_Logo_dark.svg" alt="Allen Jackson Logo" class="logo-image">
    <!-- <span class="logo-text text-[#FFF]">The Change Network</span> -->
  </div>
  <div v-if="themePreset == 'unimiddle'" class="logo-container">
    <!-- OLD: src="@/assets/images/newtheme/DJ_Dark.svg" -->
    <img v-if="isDarkMode" src="/icon/unimiddle_light.svg" alt="The Change Network Logo" class="logo-image">
    <!-- OLD: src="@/assets/images/newtheme/DJ_light.svg" -->
    <img v-else src="/icon/unimiddle_light.svg" alt="The Change Network Logo" class="logo-image">
    <!-- <span class="logo-text text-[#FFF]">The Change Network</span> -->
  </div>
</template>
<!-- 
<script setup>
defineProps(['class'])
</script> -->
<script setup>
/**
 * DougJonesMainLogo — swaps in the correct brand logo image for the active
 * theme preset, and picks the dark/light variant of that logo.
 */
import { useThemeScheme } from "@/composables/useThemeSchema";
import { useBranding } from "@/composables/useBranding";
/** Determines which logo image variant (dark/light) to render. */
const { isDarkMode } = useThemeScheme();
/** Determines which theme's logo/branding block to render. */
const { themePreset } = useBranding();

/** class — pass-through CSS class. isDark — unused legacy prop, kept for backward compatibility. */
defineProps({
  class: String,
  isDark: Boolean
});
</script>

<style scoped>
.logo-container {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  width: 100%;
}

.logo-image {
  height: 70px;
  width: auto;
}
@media (prefers-color-scheme: light) {
  .logo-text {
    /* color: #233277 !important; */
  }
}
.logo-text {
  font-size: 20px !important;
  font-weight: 600;
  color: inherit;
  white-space: nowrap;
  /* color: #fff; */
  /* font-family: Inter !important; */
}
</style>
